module.exports = __webpack_public_path__ + "static/media/universal.1109be92.svg";